import React, { useContext } from "react";
import gogo from "../image/EDUlogo.png";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { LinkData } from "../data/Link";
import { StateContext } from "../context/ContextProvider";
const Sidebar = () => {
  const navigation = useNavigate();
  const { activeMenu, setActiveMenu } = useContext(StateContext);

  const navigationTO = (index) => {
    if (index === 0) {
      navigation("/");
    }
    if (index === 1) {
      navigation("/subjects");
    }
    if (index === 2) {
      navigation("/invoice");
    }
    if (index === 4) {
      navigation("/info");
    }
    if (index === 5) {
      navigation("/chat");
    }
    if (index === 6) {
      navigation("/calender");
    }
    if (index === 7) {
      navigation("/setting");
    }
  };

  return (
    <div>
      <div
        className={` fixed z-50 ${
          activeMenu ? "   top-0 left-0  w-64" : "w-20"
        }  z-  duration-300 h-screen fixed  border-r bg-white `}
      >
        <div
          className={`text-white bg-[#610621] rounded-full absolute right-[-20px] text-3xl top-[57px] z-50 xl:hidden  cursor-pointer ${
            !activeMenu && "rotate-180"
          }`}
          onClick={() => setActiveMenu(!activeMenu)}
        >
          <IoIosArrowBack></IoIosArrowBack>
        </div>

        <div className={` ${activeMenu ? "w-64" : "w-20"}`}>
          <div className=" h-[70px] border-b border-gray-200">
            {activeMenu ? (
              <div
                className={`text-[#610621] text-xl font-bold  p-2 flex items-center  ${
                  !activeMenu && "scale-0"
                }  `}
              >
                <img src={gogo} alt="EDU Logo" className="h-14 mr-3 "></img>
                East Delta
              </div>
            ) : (
              <div
                className={`text-[#610621] text-2xl font-bold text-center pt-5 `}
              >
                EDU
              </div>
            )}
          </div>

          <ul className="pt-6">
            {LinkData.map((Menu, index) => (
              <li
                onClick={() => navigationTO(index)}
                key={index}
                className={` w-full duration-300 text-[#5e5873] font-medium mt-4  flex items-center gap-x-3 p-4 pl-7 cursor-pointer hover:pl-8
              ${Menu.gap ? "mt-9" : "mt-2"} ${
                  index === 0 && "bg-light-white"
                } `}
              >
                <div
                  className={` text-2xl ${
                    !activeMenu && " w-full flex items-center justify-center"
                  }`}
                >
                  <div className="">{Menu.icon}</div>
                </div>
                <span className={`${!activeMenu && "hidden  "} `}>
                  {Menu.title}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;